<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <pay-bill-item
    :key="type"
    :type="type"
    @tab="onTab"
  ></pay-bill-item>
</template>

<script>
/** 应付订单 */

import payBillItem from './children/pay_bill_item';

export default {
  name: 'payBill',
  mixins: [],
  components: {
    payBillItem
  },
  data() {
    return {
      // 3- 全部 1 - 待收款，2 - 已收款
      type: 3
    };
  },
  mounted: function () {

  },
  methods: {
    onTab(value) {
      this.type = value;
    }
  },
};
</script>

<style lang="scss">
</style>
